import React, { ReactElement } from 'react';
import { Box, Typography, Grid } from '@mui/material';
import { CompetencyProgressBar } from './CompetencyProgressBar';

interface Competency {
  label: string;
  hours: string;
  events: number;
  progress: number;
  color: string;
}

interface CompetenciesSectionProps {
  title: string;
  subtitle: string;
  competencies?: Competency[];
  loading?: boolean;
  columnCount?: number;
}

export const CompetenciesSection = ({
  title,
  subtitle,
  competencies,
  loading = false,
  columnCount = 2,
}: CompetenciesSectionProps): ReactElement => {
  const displayCompetencies = competencies || [];
  const chunkSize = Math.ceil(displayCompetencies.length / columnCount) || 1;
  const columns = Array.from({ length: columnCount }, (_, index) =>
    displayCompetencies.slice(index * chunkSize, (index + 1) * chunkSize),
  );
  const columnWidth = Math.floor(12 / columnCount) || 12;

  if (loading) {
    return (
      <Box sx={{ marginBottom: '48px' }}>
        <Typography
          sx={{
            fontSize: '18px',
            fontWeight: 700,
            color: '#1F1F1F',
            marginBottom: '8px',
          }}
        >
          {title}
        </Typography>
        <Typography
          sx={{
            fontSize: '14px',
            color: '#6B6B6B',
            marginBottom: '24px',
          }}
        >
          Loading...
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ marginBottom: '48px' }}>
      <Typography
        sx={{
          fontSize: '18px',
          fontWeight: 700,
          color: '#1F1F1F',
          marginBottom: '8px',
        }}
      >
        {title}
      </Typography>
      <Typography
        sx={{
          fontSize: '14px',
          color: '#6B6B6B',
          marginBottom: '24px',
        }}
      >
        {subtitle}
      </Typography>

      <Grid container spacing={12}>
        {columns.map((column, columnIndex) => (
          <Grid item xs={12} sm={6} md={columnWidth} key={columnIndex}>
            {column.map((comp, index) => (
              <CompetencyProgressBar key={index} {...comp} />
            ))}
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};
